import React from 'react';
import { styled } from 'styled-components';
import errImage from '../assets/images/error.svg';
export const ErrorPage = () => {
    const reloadOnClick = () => {
        localStorage.clear();
        window.location.reload();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: 'calc(100vh - 120px)',
            } },
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%',
                    maxWidth: '600px',
                    fontFamily: 'Arial, sans-serif',
                } },
                React.createElement("img", { style: { maxWidth: '80%' }, src: errImage }),
                React.createElement("h1", null,
                    "Something went wrong. Please try again. If the problem persists, please contact support",
                    ' ',
                    React.createElement("a", { href: "mailto:vbox0n42@debbie-4f1d4ff0a38d.intercom-mail.com?subject=Debbie%20is%20crashing" }, "here"),
                    "."),
                React.createElement(Button, { type: "button", value: "Try again", onClick: reloadOnClick })))));
};
const Button = styled.input `
  width: 100%;
  padding: 10px 20px;
  margin-top: 20px;
  font-size: 16px;
  font-weight: bold;
  background-color: #200d54;
  color: #fff;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: #2c0f7f;
  }
`;
//# sourceMappingURL=ErrorPage.js.map